export default __webpack_public_path__ + "static/media/91.81696b63.jpg";